import React, { useState, useCallback, useEffect } from "react";
import {
  FormLayout,
  TextField,
  Checkbox,
  Button,
  Text,
  Select,
  ButtonGroup,
  Popover,
  Icon,
  ActionList,
  Banner,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import {
  LanguageIcon,
  QuestionMarkMinor,
  MenuVerticalIcon,
  ColorsMajor,
} from "@shopify/polaris-icons";
import EditorTiny from "./EditorTiny";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import Instruction from "./Instruction";
import { accessEditSections } from "../Helpers";
import AsyncSelect from "react-select/async";
import instructionImg from "../Assets/Images/instruction-help.svg";

const ObjectSection = (props) => {
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  const [data, setData] = useState([]);
  let object = JSON.parse(props.object);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeDate = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, date: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    !props.shopifyDomainFound &&
      setOptionsCtaLinkType(
        optionsCtaLinkType.filter(
          (item) =>
            item.label !== "Shopify Product" &&
            item.label !== "Shopify Collection"
        )
      );
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            date:
              object?.details && object?.details?.event_date
                ? object?.details?.event_date
                : "",
            subtitle:
              object?.subtitle && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            ctaLinkType:
              object?.details?.cta_link_type !== null
                ? String(object?.details?.cta_link_type)
                : "",
            ctaText:
              object?.details?.cta_text &&
              object?.details?.cta_text[element.value]
                ? object?.details?.cta_text[element.value]
                : "",
            ctaLink:
              object?.details?.cta_link &&
              object?.details?.cta_link[element.value]
                ? object?.details?.cta_link[element.value]
                : "",
            ctaLinkPage: object?.details?.cta_page_alias
              ? object?.details?.cta_page_alias
              : "",
            ctaLinkBlog: object?.details?.cta_blog_alias
              ? object?.details?.cta_blog_alias
              : "",
            ctaLinkCollection: {
              label:
                object?.details && object?.details?.cta_shopify_collection_title
                  ? object?.details?.cta_shopify_collection_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_collection_id
                  ? object?.details?.cta_shopify_collection_id
                  : "",
              handle:
                object?.details &&
                object?.details?.cta_shopify_collection_handle
                  ? object?.details?.cta_shopify_collection_handle
                  : "",
            },

            ctaLinkProduct: {
              label:
                object?.details && object?.details?.cta_shopify_product_title
                  ? object?.details?.cta_shopify_product_title
                  : "",
              value:
                object?.details && object?.details?.cta_shopify_product_id
                  ? object?.details?.cta_shopify_product_id
                  : "",
              handle:
                object?.details && object?.details?.cta_shopify_product_handle
                  ? object?.details?.cta_shopify_product_handle
                  : "",
            },
            text:
              object?.details &&
              object?.details?.expiration_message &&
              object?.details?.expiration_message[element.value]
                ? object?.details?.expiration_message[element.value]
                : "",
            active: object?.details?.is_active ? true : false,
            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
          };
        })
    );
  }, [props.object]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MenuVerticalIcon} />
    </Button>
  );
  // useEffect(() => {
  //   const divEl = document.getElementById("container");

  //   divEl.addEventListener("dragstart", (event) => {
  //     event.preventDefault();
  //   });

  //   divEl.addEventListener("drop", (event) => {
  //     event.preventDefault();
  //   });
  // }, []);

  const handleSelectChangeCtaLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };

  const [optionsCtaLinkType, setOptionsCtaLinkType] = useState([
    { label: "External Link", value: "1" },
    { label: "Page", value: "2" },
    { label: "Blog", value: "3" },
    { label: "Shopify Product", value: "4" },
    { label: "Shopify Collection", value: "5" },
  ]);
  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectChangePage = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyCollection, setSelectedShopifyCollection] =
    useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyProduct, setSelectedShopifyProduct] = useState("");
  const handleSelectChangeShopifyProduct = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);
  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  return (
    // <div className="no-click" onMouseDown={() => console.log("downn")}>
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}

      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageIcon : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>
      <div style={{ overflow: "auto", minWidth: "100%" }}>
        <table>
          <tbody>
            <tr>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              {translatedButtonClicked && (
                <th>
                  {/* <Banner
                  title="Please select a language before you fill information"
                  status="info"
                  onDismiss={() => {}}
                ></Banner> */}
                  <Select
                    options={props.languagesArray}
                    onChange={handleSelectChangeLanguage}
                    value={selectedLanguage}
                    placeholder="Please select a language"
                  />
                </th>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Title
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").title
                  }
                  onChange={handleChangeTitle}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).title
                    }
                    onChange={handleChangeTitleTranslated}
                  />
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        {/* <Button
          primary
          onClick={() => {
            props.handleSavingState();
            axios
              .delete(`/pages/${id}/sections/${props.sectionId}`)
              .then((result) => {
                props.handleDeleteAndRefresh();
              })
              .catch((err) => console.log(err));
          }}
          loading={props.isSaving}
          destructive
          fullWidth
        >
          Delete
        </Button> */}
        <div style={{ float: "right" }}>
          <Button
            variant="primary"
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
    </FormLayout>
    // </div>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));

    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );

    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    form_data.append("_method", "PATCH");

    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default ObjectSection;
